import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-payment-response',
    imports: [CommonModule, ButtonModule],
    templateUrl: './payment-response.component.html',
    styleUrl: './payment-response.component.scss'
})
export class PaymentResponseComponent {
  paymentStatus = '';
  countdown = 10;
  private intervalId: any;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.paymentStatus = params['status'] || 'error';
      if (this.paymentStatus === 'success') {
        //this.startCountdown();
      }
    });
  }

  startCountdown() {
    this.intervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.intervalId);
        this.goToDashboard();
      }
    }, 1000);
  }

  goToDashboard() {
    if (this.intervalId) clearInterval(this.intervalId);
    this.router.navigate(['/app/dashboard']);
  }

  goToPayments() {
    if (this.intervalId) clearInterval(this.intervalId);
    this.router.navigate(['/app/pagos/pagar']);
  }
}
